import React, { useEffect } from "react";
import { CustomSelect } from "../parts/CustomSelect";
import { FORM_USER_INFORMATION } from "../config/form";
import { required, isShortRange, isKana, isHankakuNumberFormat, isZenkaku } from "../util/validate";
import { call_api, updateValues } from "../util/util";
import { displayName } from "../config/config";
import { Layout } from "../Layout/Layout";
import { SectionWithText } from "../Layout/SectionWithText";
import { InputText } from "../parts/InputText";
import { FormValidationError } from "../components/FormValidationError";
import { TermInputPair } from "../Layout/TermInputPair"
import { CollapseTextView } from "../components/CollapseTextView"
import { ZipCodeSearch } from "../components/ZipCodeSearch";
import { Submit } from "../components/Submit";
import { SystemError } from "../components/SystemError";
import liff from '@line/liff';
import { InputTel } from "../parts/InputTel";

export function UserInformationRegister(props) {
  const liffState = props.liffState
  const [room_id, setRoomId] = React.useState(props.roomId);
  const [values, setValues] = React.useState(FORM_USER_INFORMATION);
  const [isBot, setIsBot] = React.useState(false);
  const [guestId, setGuestId] = React.useState("");
  const [snsType, setSnSType] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);
  const [loadLabel, setLoadLabel] = React.useState("検索中...");
  const [isSucess, setIsSucess] = React.useState(false);
  const [isExprided, setIsExprided] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState("タイムアウトのため無効なリンクです。")
  const [isTermAgree, setTermAgree] = React.useState(false);
  const [fetchInitialDataFinish, setFetchInitialDataFinish] = React.useState(false);
  const [mansionAddressList, setMansionAddress] = React.useState([]);
  const [mansionData, setMansionData] = React.useState([]);
  const [isSearchClick, setIsSearchClick] = React.useState(false);
  let errCount = 0

  useEffect(() => {
    document.title = displayName.TOKYU_TITLE;
    fetchInitialData(props.roomId);
  }, []);

  //郵便番号検索処理
  async function searchClick() {
    const yubinBangou = values.yubinBangou.value;
    const isRequiredError = required(yubinBangou);
    const isRangeError = isShortRange(yubinBangou, 7);
    const ishanKakuNumberError = isHankakuNumberFormat(yubinBangou);

    handleError("yubinBangou", "requiredSearchAddressError", false)
    handleError("yubinBangou", "notFoundAddressError", false)
    handleError("yubinBangou", "requiredError", isRequiredError)
    handleError("yubinBangou", "rangeError", isRangeError)
    handleError("yubinBangou", "ishanKakuNumberError", ishanKakuNumberError)

    if (isRequiredError || isRangeError || ishanKakuNumberError) return;
    let payload = { "yubinBango": yubinBangou }
    let response = await call_api(process.env.REACT_APP_TOKYU_BASE_API_URL + "get-mansion-info", payload)
    var address = []
    console.log(response)
    if (response.statusCode === 200) {
      handleError("yubinBangou", "serverAddressError", false)
      setMansionData(response.result)
      address = response.result.map((item) => ({ value: item.bukkenCd, label: item.bukkenName }))
    } else {
      handleError("yubinBangou", "serverAddressError", true)
      return
    }

    const notFound = address.length === 0
    handleError("yubinBangou", "notFoundAddressError", notFound)
    if (notFound) {
      setMansionAddress([])
      handleLabel("mansionName", "")
    } else {
      let defaultItem = { value: "", label: "- こちらからご選択ください -" }
      address.unshift(defaultItem)
      setMansionAddress(address)
      handleLabel("mansionName", defaultItem.label)
    }

  }

  //初期表示処理
  async function fetchInitialData(_room_id) {

    if (liff.isInClient()) {
      liff.init({
        liffId: process.env.REACT_APP_LIFF_ID_USER_REGISTER
      }).catch((err) => {
        alert(err);
      })
    }

    var liffRoomId = ""

    if (liffState) {
      let params = encodeURI(liffState)
      liffRoomId = params.slice(8, 32)
      console.log(liffRoomId);
    }

    var room_id = _room_id
    if (!_room_id) {
      setRoomId(liffRoomId)
      room_id = liffRoomId
    }

    let form = { "room_id": room_id, }
    let result = await call_api(process.env.REACT_APP_TOKYU_BASE_API_URL + "get-room-info", form)
    console.log(result)
    if (result.status_code === "200") {
      setIsExprided(result.is_room_close)
      setErrorMsg("タイムアウトのため無効なリンクです。")
      setIsBot(result.is_bot)
      setGuestId(result.world)
      setSnSType(result.roomInfo.tag62)
      let address = result.roomInfo.tag34
      if (address && address.length > 7) {
        handleValue("yubinBangou", address.slice(0, 3) + address.slice(4, 8))
      }
      if (result.roomInfo.tag249 === "1") {
        updateValues({ ["yubinBangou"]: { isEdit: true } }, setValues);
      }
      handleLabel("mansionName", (result.roomInfo.tag32) ? result.roomInfo.tag32 : "")
      handleValue("roomNo", (result.roomInfo.tag33) ? result.roomInfo.tag33 : "")
      handleValue("applicantFullName", (result.roomInfo.tag35) ? result.roomInfo.tag35 : "")
      handleValue("applicantKana", (result.roomInfo.tag36) ? result.roomInfo.tag36 : "")
      handleValue("denwaBango", (result.roomInfo.tag37) ? result.roomInfo.tag37 : "")

      setFetchInitialDataFinish(true)
    } else {
      setIsExprided(true)
      setErrorMsg("通信エラーが発生しました。\n画面を閉じて、エラーの旨をオペレータにお伝えください。")
    }
  }

  //初期データ反映
  async function initialViewState(defaultViewSetting, roomInfo, extendedRoomTag) {
    //入力内容復元
    //編集不可
  }

  //送信処理
  async function submit() {
    //入力チェック
    errCount = 0
    Object.keys(values).forEach(fieldName => {
      const field = values[fieldName];
      if (field.hasOwnProperty("requiredError")) {
        handleError(fieldName, "requiredError", required(field.value));
      }
      if (field.hasOwnProperty("rangeErrorSubmit")) {
        handleError(fieldName, "rangeErrorSubmit", isShortRange(field.value, field.minLength));
      }
      if (field.hasOwnProperty("kanaError") && fieldName !== "yubinBangou") {
        handleError(fieldName, "kanaError", isKana(field.value) || isZenkaku(field.value));
      }

    });

    //マンション名の選択を確認する
    if (values.yubinBangou.value) {
      handleError("yubinBangou", "requiredSearchAddressError", mansionAddressList.length == 0)

    }

    // 相関チェック
    window.scrollTo({ top: 0, behavior: 'smooth', })
    // handleError("yubinBangou", "requiredError", false)
    handleError("yubinBangou", "rangeError", false)
    handleError("yubinBangou", "notFoundAddressError", false)
    handleError("yubinBangou", "notKyusyuError", false)

    //API連携
    if (errCount === 0) {
      let selectedItem = mansionData.find(item => item.bukkenCd === values.mansionName.value)
      //API連携
      let form = {
        "formName": "FORM_USER_INFORMATION",
        "masionCode": selectedItem.bukkenCd,
        "mansionAdrress": selectedItem.bukkenZipCode + " " + selectedItem.bukkenAddress,
        "mansionName": values.mansionName.label,
        "roomNo": values.roomNo.value,
        "applicantFullName": values.applicantFullName.value,
        "applicantKana": values.applicantKana.value,
        "denwaBango": values.denwaBango.value,
        "room_id": room_id,
        "is_bot": isBot,
        "sns_type": snsType,
        "world": guestId
      }
      console.log(form)
      let result = await call_api(process.env.REACT_APP_TOKYU_BASE_API_URL + "user-infor-register", form)
      console.log(result)

      if (result.statusCode == "200") {
        setValues({ ...values, "systemError": false })
        setIsSucess(true)
        liff.closeWindow()
        window.close()
        window.open("", "_self");
        window.close();
      } else {
        setValues({ ...values, "systemError": true });
      }
    }
  }

  //以下ハンドラー
  function handleValue(name, value) {
    updateValues({ [name]: { value } }, setValues);
  }
  function handleLabel(name, value) {
    updateValues({ [name]: { label: value } }, setValues);
  }
  function handleError(name, error, bool) {
    const updatedValues = { [name]: { [error]: bool } };
    if (bool) errCount += 1;
    updateValues(updatedValues, setValues);
  }
  function mansionSelectChange(name, value) {
    let selectedMansion = mansionAddressList.find(item => item.value === value)
    handleValue(name, value)
    handleLabel(name, selectedMansion.label)
  }

  return (
    <>
      {(fetchInitialDataFinish && !isSucess && !isExprided) &&
        <Layout isLoading={isLoading} label={loadLabel}>
          <SectionWithText>

            <dl>
              <dt className="required">{"マンション名"}</dt>
              <div className="yubin container">
                <div className="search-yubin">
                  <TermInputPair label="郵便番号検索" annotation="※ハイフン無しでご入力ください" className="zip">
                    <ZipCodeSearch name="yubinBangou" formData={values.yubinBangou} searchClick={searchClick} handleValue={handleValue}></ZipCodeSearch>
                  </TermInputPair>
                  <FormValidationError formDataList={[values.yubinBangou]} type={"yubinBangou"}></FormValidationError>
                </div>
                {(mansionAddressList.length > 0) &&
                  <div>
                    <TermInputPair label="マンション名" required={true}>
                      <CustomSelect name="mansionName" options={mansionAddressList} formData={values.mansionName} handleValue={mansionSelectChange} />
                    </TermInputPair>
                    <FormValidationError formDataList={[values.mansionName]} type={"addressSelect"}></FormValidationError>
                  </div>
                }
              </div>
            </dl>

            <TermInputPair label="棟・部屋番号" required={true}>
              <InputText name="roomNo" formData={values.roomNo} handleValue={handleValue}></InputText>
            </TermInputPair>
            <FormValidationError formDataList={[values.roomNo]} type={"textInput"}></FormValidationError>
            <TermInputPair label="お名前（フルネーム）" required={true}>
              <InputText name="applicantFullName" formData={values.applicantFullName} handleValue={handleValue}></InputText>
            </TermInputPair>
            <FormValidationError formDataList={[values.applicantFullName]} type={"textInput"}></FormValidationError>
            <TermInputPair label="フリガナ（フルネーム）" required={true}>
              <InputText name="applicantKana" formData={values.applicantKana} handleValue={handleValue}></InputText>
            </TermInputPair>
            <FormValidationError formDataList={[values.applicantKana]} type={"textInput"}></FormValidationError>
            <TermInputPair label="ご連絡がつく電話番号" annotation="※ハイフン無しでご入力ください" required={true}>
              <InputTel name="denwaBango" formData={values.denwaBango} handleValue={handleValue}></InputTel>
            </TermInputPair>
            <FormValidationError formDataList={[values.denwaBango]} type={"textInput"}></FormValidationError>
            <dl>
              <div className=""><p className="">ご相談・お問い合わせの前にご一読ください。</p></div>
            </dl>
            <CollapseTextView>
              {"個人情報の取扱いについて\n株式会社東急コミュニティーは、お客さまがお問い合わせフォームに入力された個人情報につきまして、弊社の個人情報保護方針に基づき、下記の通り取り扱いいたします。\n\n１．利用目的\n\n　お問い合わせに対する回答のため\n\n２．保有個人データの第三者提供\n\n　保有個人データは、お客さまの同意なく第三者提供いたしません。但し、法令に基づく場合を除きます。\n\n３．保有個人データの委託\n\n　保有個人データは、利用目的の達成のため、弊社の業務委託先に委託する場合がございます。\n\n４．保有個人データに関するお問合せ窓口\n\n（１）保有個人データの利用目的の通知\n\n（２）保有個人データ又は第三者提供記録の開示\n\n（３）保有個人データの訂正、追加又は削除\n\n（４）保有個人データの利用の停止、消去又は第三者提供の停止\n\n保有個人データに関する上記（１）から（４）についてのお問い合わせは、下記の窓口にて受付いたします。\n\n《保有個人データに関するお問い合わせ窓口》\n\n株式会社東急コミュニティー　　グループ総務部個人情報保護担当窓口\n住所：〒158-8509\n東京都世田谷区用賀４－１０－１世田谷ビジネススクエア タワー\nURL："}
              <a href="https://www.tokyu-com.co.jp/inquiry/form/privacy/" target="_blank" rel="noopener noreferrer">https://www.tokyu-com.co.jp/inquiry/form/privacy/</a>
              {"\n\n尚、保有個人データの利用目的の通知及び、保有個人データ又は第三者提供記録の開示の手続きにつきましては、お客さまより手数料をいただきます。\n当該手続きに関する詳細や、保有個人データに関する苦情の申出先及び、安全管理のために講じられる措置等については、下記のリンク先よりご確認ください。\n【個人情報の保護に関する法律に基づく公表事項について】\n\n５．個人情報提供の任意性について\n\n　お問い合わせフォームへの個人情報のご提供は、任意です。但し、お客さまから個人情報をご提供いただけない場合は、お問合せ・ご相談に対応できない場合がございます。予めご承知おき願います。\n\n"}
              {"2025年10月 1日"}
              {"\n株式会社東急コミュニティー\n個人情報統括責任者　経営管理統括部長"}
            </CollapseTextView>
            <div id="userPolicyAgreement">
              <input
                type="checkbox"
                style={{ margin: "8px", transform: "scale(1.3)" }}
                onClick={(e) => setTermAgree(e.target.checked)}
              />
              <label>{"個人情報の取扱いについて同意します"}</label>
            </div>
          </SectionWithText>
          <Submit disabled={!isTermAgree} label="送信" onClick={submit} error={values.systemError}></Submit>
        </Layout>
      }
      {
        isExprided &&
        <Layout>
          <SectionWithText>
            <SystemError error_msg={errorMsg} />
          </SectionWithText>
        </Layout>
      }
      {
        isSucess &&
        <Layout>
          <SectionWithText>
            <div id="success">
              <p >{"この画面を閉じてチャットルームへお戻りください。"}</p>
            </div>
          </SectionWithText>
        </Layout>
      }
    </>
  );
}
